import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '久久在线观看是否需要注册才能观看视频？',
    answer: '不需要！久久在线观看所有视频资源均可免费观看，无需注册登录。打开网站即可立即享受高清流畅的观影体验，真正做到即点即看。',
  },
  {
    question: '久久在线观看支持哪些设备访问？',
    answer: '久久在线观看支持所有主流设备，包括电脑（Windows/Mac）、平板（iPad/Android平板）和手机（iPhone/Android手机）。只需一个浏览器，随时随地久久在线观看。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '久久在线观看采用全球CDN加速技术，通常情况下视频可以流畅播放。如果遇到卡顿，建议检查网络连接状态，或尝试切换视频清晰度。您也可以刷新页面重新加载。',
  },
  {
    question: '久久在线观看的视频画质如何？',
    answer: '我们提供从标清到4K超清多种画质选择。大部分热门电影和电视剧都支持1080P全高清甚至4K超清画质，为您带来极致的视觉享受。久久在线观看坚持高清品质。',
  },
  {
    question: '久久在线观看的资源多久更新一次？',
    answer: '我们的内容团队每天都会更新最新上线的影视资源，热门电视剧播出后24小时内即可在久久在线观看找到。综艺节目和动漫也会及时跟进更新。',
  },
  {
    question: '久久在线观看是否需要下载播放器？',
    answer: '完全不需要！久久在线观看是基于网页的在线视频平台，无需下载任何播放器或插件。使用浏览器自带的HTML5播放器即可直接观看所有视频。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-10 md:py-14 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">常见问题</h2>
            <p className="text-sm text-foreground-500 mt-2">关于久久在线观看的常见疑问解答</p>
          </div>
          <div className="space-y-3">
            {faqData.map((item, index) => (
              <div key={index} className="rounded-xl bg-background-100 overflow-hidden">
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-800 pr-4">{item.question}</span>
                  <div className={`w-6 h-6 flex items-center justify-center shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}